export default {
  'lv6':[{
    title:'I want to sail it here all __ myself.',
    choose:['with','of','by','in'],
    answer:'by'
  },{
    title:'He just ___ me to feed him all by myself.',
    choose:['like','likes','liking','liked'],
    answer:'likes'
  },{
    title:'No, I can __ good hits like this one all by myself.',
    choose:['does','do','did','done'],
    answer:'do'
  },{
    title:'I would like to help you __ your kite.',
    choose:['flying','flyed','flys','fly'],
    answer:'fly'
  },{
    title:'“Look __ my scissors,” said Mrs Snip Snap.',
    choose:['in','out','at','wtih'],
    answer:'at'
  },{
    title:'That’s my hair! Go ___ !',
    choose:['out','away','way','right'],
    answer:'away'
  },{
    title:'My kite will __ away if you cut that rope.',
    choose:['flying','fly','flys','flyed'],
    answer:'fly'
  },{
    title:'I will run away if you __ that.',
    choose:['did','doing','does','do'],
    answer:'do'
  },{
    title:'The artist wanted to ___ pictures of some animals.',
    choose:['paints','painting','paint','painted'],
    answer:'paint'
  },{
    title:'I can see __ animal with a long neck.',
    choose:['a','an','the','big'],
    answer:'an'
  },{
    title:'__ want to be in your picture.',
    choose:['me','I','my','myself'],
    answer:'I'
  },{
    title:'Now I can paint a picture of ___!',
    choose:['me','my','I','myself'],
    answer:'myself'
  },{
    title:'Come to ___ home to have dinner soon.',
    choose:['me','I','my','at'],
    answer:'my'
  },{
    title:'Stork could __ the food.',
    choose:['saw','see','sees','seeing'],
    answer:'see'
  },{
    title:'The next day Stork went back to      house.',
    choose:['Fox','Fox’s','Foxs'],
    answer:'Fox’s'
  },{
    title:'They ___ good friends again.',
    choose:['is','was','am','were'],
    answer:'were'
  },{
    title:'We can make a set of shoes that ___ the same size.',
    choose:['is','was','are','were'],
    answer:'are'
  },{
    title:'Which one is the odd one out __',
    choose:['“.”','“?”','“!”','“,”'],
    answer:'“?”'
  },{
    title:'The cap ___ the same kind as the other hats.',
    choose:['isnot','isn’t','isnt','are'],
    answer:'isn’t'
  },{
    title:'Which one will __ that odd one out.',
    choose:['is','are','was','be'],
    answer:'be'
  },{
    title:'Polar bears __ in the snow and ice',
    choose:['lived','lives','live','living'],
    answer:'live'
  },{
    title:'It is fun __ ride on snow.',
    choose:['for','to','of','by'],
    answer:'to'
  },{
    title:'Snow monkeys live in a __ __ place.',
    choose:['cold very','very cold'],
    answer:'very cold'
  },{
    title:'Their fur keeps ___ warm.',
    choose:['their','they','them'],
    answer:'them'
  },{
    title:'You need exercise to keep your body __.',
    choose:['health','healthy'],
    answer:'healthy'
  },{
    title:'You __ get much energy from bad food.',
    choose:['doesn’t','don’t','aren’t','isn’t'],
    answer:'don’t'
  },{
    title:'There are lots of other __ to keep fit.',
    choose:['way','ways','wayes'],
    answer:'ways'
  },{
    title:'How __ sleep do you think you need?',
    choose:['some','many','much'],
    answer:'much'
  },{
    title:'Pizza is quick __ cook.',
    choose:['for','with','to','by'],
    answer:'to'
  },{
    title:'Put it in some __.',
    choose:['flours','flour','floures'],
    answer:'flour'
  },{
    title:'Make it into a round shape with your __.',
    choose:['hand','hands','handes'],
    answer:'hands'
  },{
    title:'__ ready to eat now.',
    choose:['Its','It was','It','It is'],
    answer:'It is'
  },{
    title:'Then __ enemy can’t see it swimming away.',
    choose:['it','it’s','its'],
    answer:'its'
  },{
    title:'They fly away and look __ other food.',
    choose:['at','for','into','out'],
    answer:'for'
  },{
    title:'Its prickles stop an enemy from __ it.',
    choose:['attack','attacking','attacks','attacked'],
    answer:'attacking'
  },{
    title:'A lizard __ good ways to get away from an enemy.',
    choose:['have','had','has'],
    answer:'has'
  },{
    title:'They crawl around ___ for food.',
    choose:['look','looks','looking','looked'],
    answer:'looking'
  },{
    title:'___ live in places that are dirty.',
    choose:['Flys','Flies','Flyes'],
    answer:'Flies'
  },{
    title:'They don’t buzz, but they sing when the sun __.',
    choose:['shine','shines','shining'],
    answer:'shines'
  },{
    title:'Butterflies come       caterpillars.',
    choose:['to','with','into','from'],
    answer:'from'
  },]
}



// WEBPACK FOOTER //
// ./src/testdata/missing.js